import format from '@/plugins/baseFormat';
import { STATUS, STATUS_COLORS, } from '@/modules/drivers/constants';
export default class DriverOccurrence {
  constructor (initialData = {},) {
    const {
      _id,
      code,
      created_at,
      description,
      financial_occ_type,
      from,
      occurrence_date,
      status,
      reason,
      related_link,
      value,
      attachments,
      orientation,
      foward_to,
      driver_return,
    } = initialData;
    this._id = _id;
    this.code = code;
    this.created_at = created_at;
    this.description = description;
    this.financial_occ_type = financial_occ_type;
    this.from = from;
    this.occurrence_date = occurrence_date;
    this.reason = reason;
    this.related_link = related_link;
    this.value = value;
    this.status = status;
    this.attachments = attachments;
    this.orientation = orientation;
    this.foward_to = foward_to;
    this.driver_return = driver_return;
  }

  set driverOccurrence (driverOccurrence,) {
    this._id = driverOccurrence._id;
    this.code = driverOccurrence.code;
    this.created_at = driverOccurrence.created_at;
    this.description = driverOccurrence.description;
    this.financial_occ_type = driverOccurrence.financial_occ_type;
    this.from = driverOccurrence.from;
    this.occurrence_date = driverOccurrence.occurrence_date;
    this.reason = driverOccurrence.reason;
    this.related_link = driverOccurrence.related_link;
    this.value = driverOccurrence.value;
    this.status = driverOccurrence.status;
    this.attachments = driverOccurrence.attachments;
    this.orientation = driverOccurrence.orientation;
    this.foward_to = driverOccurrence.foward_to;
    this.driver_return = driverOccurrence.driver_return;
  }

  get formatted_occurrence_created_date () {
    return format.dateFromNow(this.created_at,);
  }

  get formatted_occurrence_date () {
    return format.dateFromNow(this.occurrence_date,);
  }

  get formatted_status () {
    return STATUS[this.status] || 'Desconhecido';
  }

  get status_color () {
    return STATUS_COLORS[this.status] || 'gray';
  }

  get formatted_created_at () {
    return format.dateFromNow(this.created_at,);
  }
  get formatted_financial_occ_type () {
    return this.financial_occ_type || '-';
  }

  get formatted_value () {
    return this.value ? format.money(this.value,) : 0;
  }
}
